import { RecurringExpenseResponseDto } from '@trellis/api'

type ExpenseStatus = RecurringExpenseResponseDto['status']
type PillStyles = { pill: string; dot: string }

export const EXPENSE_STATUS_STYLES: Record<ExpenseStatus, PillStyles> = {
  CANCELLED: { pill: 'bg-stone-100 text-stone-600', dot: 'bg-stone-400' },
  ACTIVE: { pill: 'bg-blue-100 text-blue-700', dot: 'bg-blue-500' },
  PAUSED: { pill: 'bg-yellow-100 text-yellow-700', dot: 'bg-yellow-500' },
  COMPLETED: { pill: 'bg-green-100 text-green-700', dot: 'bg-green-500' },
}

export const CLAIMED_BADGE_STYLES = {
  CLAIMED: { pill: 'bg-emerald-50 text-emerald-800', dot: 'bg-emerald-600' },
}

export const CLAIMED_BADGE_LABELS = {
  CLAIMED: 'Claimed',
}
